module.exports = __webpack_public_path__ + "img/myposition_fb_파울로 말디니.7ef65157.png";